/* Modulo: Header Pill
   Scroll state (stuck / fixed / scroll-up), the traveling nav capsule,
   and the search + mobile-menu panels. Sections don't get the theme
   extension's core runtime, so this rolls its own init. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var SELECTOR = '[data-modulo-hpi]';
  var STUCK_AT = 24;   // px scrolled before the bar turns solid
  var HIDE_AT  = 260;  // px before scroll-up may hide the bar
  var SLOP     = 4;    // ignore sub-pixel scroll jitter

  function init(root) {
    if (root.moduloHpi) return;

    var behavior = root.dataset.hpiBehavior || 'sticky';
    var list     = root.querySelector('[data-hpi-list]');
    var glide    = root.querySelector('[data-hpi-glide]');
    var scrim    = root.querySelector('[data-hpi-scrim]');
    var cartLink = root.querySelector('[data-hpi-cart]');
    var count    = root.querySelector('[data-hpi-count]');

    var panels = {};
    var toggles = root.querySelectorAll('[data-hpi-toggle]');
    Array.prototype.forEach.call(root.querySelectorAll('[data-hpi-panel]'), function (p) {
      panels[p.dataset.hpiPanel] = p;
    });

    var state = {
      open: null,
      lastY: window.pageYOffset || 0,
      ticking: false,
      trigger: null,
      cleanup: []
    };
    root.moduloHpi = state;

    function on(target, type, fn, opts) {
      target.addEventListener(type, fn, opts);
      state.cleanup.push(function () { target.removeEventListener(type, fn, opts); });
    }

    /* ── the traveling capsule ───────────────────────────────
       Anchored to the list's physical left edge and moved by a
       physical delta, so it tracks under RTL as well. */
    function moveGlide(link) {
      if (!glide || !list) return;
      var r = link.getBoundingClientRect();
      var b = list.getBoundingClientRect();
      glide.style.setProperty('--modulo-hpi-gx', (r.left - b.left - 12) + 'px');
      glide.style.setProperty('--modulo-hpi-gw', (r.width + 24) + 'px');
    }
    if (list && glide) {
      Array.prototype.forEach.call(list.querySelectorAll('.modulo-hpi__link'), function (a) {
        on(a, 'mouseenter', function () { moveGlide(a); });
        on(a, 'focus', function () { moveGlide(a); });
      });
    }

    /* ── panels ──────────────────────────────────────────────*/
    function setPanel(name) {
      var next = name && panels[name] ? name : null;

      Object.keys(panels).forEach(function (key) {
        panels[key].classList.toggle('is-open', key === next);
      });
      Array.prototype.forEach.call(toggles, function (btn) {
        btn.setAttribute('aria-expanded', String(btn.dataset.hpiToggle === next));
      });
      root.classList.toggle('is-panel', !!next);

      if (next) {
        var focusable = panels[next].querySelector('input, a, button');
        if (focusable) {
          // Wait for visibility to flip — a hidden element can't take focus.
          window.setTimeout(function () { focusable.focus(); }, 80);
        }
      } else if (state.trigger) {
        state.trigger.focus();
        state.trigger = null;
      }
      state.open = next;
    }

    Array.prototype.forEach.call(toggles, function (btn) {
      on(btn, 'click', function () {
        var name = btn.dataset.hpiToggle;
        if (state.open === name) {
          setPanel(null);
        } else {
          state.trigger = btn;
          setPanel(name);
        }
      });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-hpi-close]'), function (btn) {
      on(btn, 'click', function () { setPanel(null); });
    });
    if (scrim) on(scrim, 'click', function () { setPanel(null); });

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && state.open) setPanel(null);
    });

    // A click anywhere outside the header closes an open panel.
    on(document, 'click', function (e) {
      if (state.open && !root.contains(e.target)) setPanel(null);
    });

    /* ── scroll state ────────────────────────────────────────*/
    var inEditor = !!(window.Shopify && window.Shopify.designMode);

    function onScroll() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var stuck = y > STUCK_AT;

      root.classList.toggle('is-stuck', stuck);

      if (behavior === 'static') {
        state.lastY = y;
        return;
      }

      root.classList.toggle('is-fixed', stuck);

      if (behavior === 'scroll_up' && !inEditor) {
        // Never hide the bar while a panel is open, or the search field
        // the shopper is typing into slides off screen.
        if (y > state.lastY + SLOP && y > HIDE_AT && !state.open) {
          root.classList.add('is-hidden');
        } else if (y < state.lastY - SLOP || y <= HIDE_AT) {
          root.classList.remove('is-hidden');
        }
      }
      state.lastY = y;
    }

    on(window, 'scroll', function () {
      if (state.ticking) return;
      state.ticking = true;
      window.requestAnimationFrame(function () {
        onScroll();
        state.ticking = false;
      });
    }, { passive: true });

    /* ── cart count ──────────────────────────────────────────
       Server-rendered, so it is correct on every page load. The one
       case that goes stale without a request is a back/forward
       restore from the bfcache, which is exactly what `persisted`
       flags — nothing else here polls. */
    if (cartLink && count && window.fetch) {
      on(window, 'pageshow', function (e) {
        if (!e.persisted) return;
        var url = cartLink.getAttribute('href');
        if (!url) return;
        window.fetch(url + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (!data || typeof data.item_count !== 'number') return;
            count.textContent = String(data.item_count);
            if (data.item_count > 0) count.removeAttribute('hidden');
            else count.setAttribute('hidden', '');
            var label = cartLink.dataset.hpiCartLabel || 'Cart';
            cartLink.setAttribute('aria-label', label + ' (' + data.item_count + ')');
          })
          .catch(function () { /* stale count is not worth a console error */ });
      });
    }

    onScroll();
  }

  function destroy(root) {
    var state = root.moduloHpi;
    if (!state) return;
    state.cleanup.forEach(function (off) { off(); });
    root.moduloHpi = null;
  }

  function bootstrap(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(host.querySelectorAll(SELECTOR), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootstrap(document); });
  } else {
    bootstrap(document);
  }

  // Theme editor: re-init on section load, tear listeners down on unload
  // so repeated edits don't stack duplicate window handlers.
  //
  // Re-inserting the section re-inserts this <script src>, and an
  // identical src still EXECUTES again — so the document-level
  // listeners have to be wired exactly once per page, not per run.
  if (!window.moduloHpiWired) {
    window.moduloHpiWired = true;

    document.addEventListener('shopify:section:load', function (e) {
      bootstrap(e.target || document);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var target = e.target;
      if (!target || !target.querySelectorAll) return;
      Array.prototype.forEach.call(target.querySelectorAll(SELECTOR), destroy);
    });
  }
})();
